<template>
  <div class="w-100 d-fx fxd-c ai-c">
    <h2 class="f-27px fw-b lh-33px c-we mt-90px">I am already a member</h2>
    <p class="w-268px t-c c-we_80 f-12px lh-18px mt-18px">Become {{this.siteData}} that changes the world with your ideas.</p>
    <button ripple="ripple" class="w-200px h-60px bo-1px bor-100px mt-30px bo-we cursor-pointer o-h" @click="updateParentSwap()">
      <span class="f-18px lh-60px c-we t-c b-bk_10-h">SIGN IN</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'UpQuestionC',
  extends: {},
  props: {
    siteData: {
      type: String,
      required: true
    }
  },
  data(){
    return{};
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    updateParentSwap() {
      this.$parent.swap = !this.$parent.swap
    }
  },
  beforeCreate(){},
  mounted(){}
}
</script>
